import pathParse from 'path-parse';
export var getImageVariantPath = function getImageVariantPath(_ref) {
  var src = _ref.src,
    size = _ref.size,
    overrideExtension = _ref.overrideExtension;
  if (typeof src !== 'string' || !size) {
    return null;
  }
  var parts = pathParse(src);
  var dir = parts.dir,
    ext = parts.ext,
    name = parts.name;
  if (!ext || !name) {
    return null;
  }
  return "".concat(dir, "/").concat(name, "@").concat(size).concat(overrideExtension || ext);
};